import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "What is the minimum order quantity (MOQ) for custom t-shirts in Mumbai?",
    a: "Customade accepts orders starting from 25 pieces for sublimation t-shirts, polos, oversized tees and hoodies. For boiler suits and windcheaters the MOQ is also 25 pieces. Bulk pricing tiers begin at 50, 100, 250 and 500+ pieces — the larger the order, the better the per-piece rate.",
  },
  {
    q: "How long does it take to deliver a custom t-shirt order?",
    a: "Standard turnaround for fully customised orders is 7 to 10 working days from artwork approval. Sublimation jerseys and embroidery polos typically take 8–12 days. Boiler suits and windcheaters take 12–18 days because they're fully stitched to spec. Rush orders can be delivered in 4–5 days for an additional charge.",
  },
  {
    q: "What printing techniques does Customade offer?",
    a: "We offer all major customisation methods under one roof: full-fabric sublimation (best for sports jerseys and colour-rich designs), DTF (direct-to-film) for cotton tees with photo-quality prints, screen printing for high-volume bulk orders, computerised embroidery for polos and corporate uniforms, puff print for streetwear oversized tees, and heat-transfer vinyl for names and numbers.",
  },
  {
    q: "Can I order just one or two custom t-shirts?",
    a: "We're a bulk-first manufacturer, so single pieces aren't our specialty. However, we do small runs of 5–10 pieces for sample testing before a bulk order, and one-off DTF prints on cotton blanks are possible — the per-piece price is just higher than bulk rates.",
  },
  {
    q: "Which fabrics and GSM weights are available?",
    a: "Cotton round-neck tees: 180 GSM bio-washed 100% cotton in 22 shades. Cotton pique polos: 220 GSM in 25 shades. Oversized t-shirts: 180 GSM premium combed cotton in 11 modern shades. Hoodies: 320 GSM pure cotton fleece (premium) or polycotton fleece (budget). Sublimation jerseys: 140–180 GSM polyester interlock or honeycomb. Boiler suits: 220–280 GSM cotton drill or poly-cotton. Windcheaters: lightweight micro-polyester or taffeta.",
  },
  {
    q: "Do you ship across India? What about international orders?",
    a: "Yes — Customade ships pan-India through reliable courier partners (Delhivery, BlueDart, DTDC). Mumbai metro orders can be delivered in 24–48 hours after dispatch. We also accept international orders to UAE, UK, USA, Australia and Canada via DHL / FedEx — buyer pays freight + duties.",
  },
  {
    q: "Where is Customade located? Can I visit the workshop?",
    a: "Our workshop is at Gala No 5, Husseini Lakda Bazar, Nagpada, Madanpura, Mumbai – 400008, Maharashtra, India. Walk-ins are welcome 10:30 AM to 7:30 PM, Monday to Saturday. WhatsApp +91 81692 72803 to schedule a fabric consultation or sample viewing.",
  },
  {
    q: "Can you match a specific Pantone or brand colour?",
    a: "Yes — for orders of 100+ pieces in sublimation, screen print or full-fabric dye-sublimation we can colour-match to a Pantone reference within ±5%. For embroidery, we stock 200+ thread shades and can custom-source threads for exact brand match.",
  },
  {
    q: "Do you provide design / artwork services?",
    a: "Our in-house design team can mock up artwork from a rough sketch, brief or even a brand colour code. Initial design rounds are free with confirmed orders; standalone artwork is charged separately. We accept files in AI, EPS, PDF, PNG (300 DPI) or PSD format.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="border-b-4 border-black py-20 lg:py-28 bg-white"
      data-testid="faq-section"
    >
      <div className="max-w-[1100px] mx-auto px-5 md:px-10 lg:px-14">
        <div className="mb-12 lg:mb-16 max-w-3xl">
          <div className="font-heading uppercase text-xs tracking-[0.3em] text-[#555] mb-4">
            /// FAQ
          </div>
          <h2 className="font-heading uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
            Asked &amp;{" "}
            <span className="bg-[#FFE600] nb-border-2 px-2 inline-block">answered.</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#0A0A0A]/80 leading-relaxed">
            Quick answers to the most common questions about MOQ, delivery,
            printing methods, fabrics and pricing for custom apparel in Mumbai.
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          className="space-y-4"
          data-testid="faq-accordion"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="nb-border-4 nb-shadow-sm bg-white px-5 md:px-6 [&>h3]:m-0"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-heading uppercase text-left text-base md:text-lg tracking-tight py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] leading-relaxed text-[#0A0A0A]/85 pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
